import { CookieType } from 'lib/types';
import * as React from 'react';
import { IS_COOKIEBOT_ENABLED } from 'core/components/CookiebotScript/CookiebotScript';

interface PixelProps extends React.ImgHTMLAttributes<HTMLImageElement> {
    cookieType: CookieType;
}

export default function Pixel({ cookieType, ...props }: PixelProps) {
    if (IS_COOKIEBOT_ENABLED && cookieType !== 'necessary') {
        const { src, ...restProps } = props;

        return (
            <img
                data-cookieconsent={cookieType}
                data-cookieblock-src={src}
                alt={restProps.alt}
                {...restProps}
            />
        );
    }

    return <img alt={props.alt} {...props} />;
}
